import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import authAction from '../../redux/auth/actions';
import { toggleAll } from '../../redux/app/reducer';
import MySidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from './AppRouter';
// import { AppLocale } from '../../dashApp';

const { Content } = Layout;
const { logout } = authAction;

export class App extends Component {
  render() {
    const { url } = this.props.match;
    // const { locale } = this.props;
    // const currentAppLocale = AppLocale[locale];
    return (
          <Layout style={{ height: '100vh' }}>
            {/* <Debounce time="1000" handler="onResize">
              <WindowResizeListener
                onResize={windowSize =>
                  this.props.toggleAll(
                    windowSize.windowWidth,
                    windowSize.windowHeight
                  )}
              />
            </Debounce> */}
            <Topbar url={url} />
            <Layout style={{ flexDirection: 'row', overflowX: 'hidden' }}>
              <MySidebar url={url} />
              <Layout
                style={{
                  height: '100vh',
                }}
              >
                <Content
                  className="isomorphicContent"
                  style={{
                    padding: '70px 0 0',
                    flexShrink: '0',
                    background: '#FFFFFF',
                  }}
                >
                  <AppRouter url={url} />
                </Content>
              </Layout>
            </Layout>
          </Layout>
    );
  }
}

export default connect(
  state => ({
    auth: state.Auth,
   // locale: state.LanguageSwitcher.toJS().language.locale,
  }),
  { logout, toggleAll },
)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js